import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { Footer } from '../../components/Layout'
import { useAppDispatch, useAppSelector } from '../../store'
import { fetchUserInfo } from '../../store/app/app'

import { Menu } from './components/menu'

import '../../css/Home.scss'
import '../../css/HomeRightContainer.scss'

function useFetchUserInfo(): void {
  const dispatch = useAppDispatch()
  useEffect(() => {
    void dispatch(fetchUserInfo())
  }, [dispatch])
}

export function Home(): JSX.Element {
  useFetchUserInfo()
  const user = useAppSelector(state => state.app.user)

  return (
    <div className='home'>
      <div className='flex flex-row'>
        {user?.email && <Menu />}
        <div className='p-8 w-[100%] overflow-x-scroll'>
          <Outlet />
          <Footer />
        </div>
      </div>
    </div>
  )
}
